/**
 * Removes extraneous slashes in a URL path.
 *
 * @example
 *  deduplicateSlashes('/app///path/to//stuff')
 *  > '/app/path/to/stuff'
 */
const deduplicateSlashes = (url: string) => url.replace(/\/{2,}/g, '/');

export default deduplicateSlashes;
